import * as React from "react";

interface ITableBooleanFilterProps {
    value: boolean;
    trueLabel: string;
    falseLabel: string;
    onChange: (updatedValue: boolean) => void;
}

function TableBooleanFilter(p: ITableBooleanFilterProps) {

    return (
        <div className="btn-group btn-group-toggle mb-1" data-toggle="buttons">
            <label className={p.value ? "btn btn-secondary " : "btn btn-secondary active"} onClick={trueClicked} >
                {p.trueLabel}
            </label>
            <label className={p.value ? "btn btn-secondary active" : "btn btn-secondary"} onClick={falseClicked} >
                {p.falseLabel}
            </label>
        </div>
    );

    function trueClicked() {
        if (!p.value) {
            p.onChange(true);
        }
    }

    function falseClicked() {
        if (p.value) {
            p.onChange(false);
        }
    }
}

export default TableBooleanFilter;



// WEBPACK FOOTER //
// ./src/core/TableBooleanFilter/TableBooleanFilter.tsx